import { IconButton } from '@/lib';
import { FC } from 'react';

import { CheckCircleIcon } from '@heroicons/react/outline';
import EditIcon from '@/assets/icons/edit.svg?react';

type ChangeDataSourceNameButtonProps = {
  isLoading?: boolean;
  isEditingName?: boolean;
  onDataSourceRenameConfirm?: VoidFunction;
  onEditClick?: VoidFunction;
};

export const ChangeDataSourceNameButton: FC<ChangeDataSourceNameButtonProps> = ({ isEditingName, isLoading, onDataSourceRenameConfirm, onEditClick }) => {
  if (isEditingName) {
    return (
      <IconButton
        intent='link-grey'
        className='!p-1'
        leadingIcon={<CheckCircleIcon className='size-5 text-brand-600' />}
        isLoading={isLoading}
        onClick={onDataSourceRenameConfirm}
      />
    );
  }

  return <IconButton intent='link-grey' className='!p-1' leadingIcon={<EditIcon className='size-5' />} onClick={onEditClick} />;
};
